export const handlepaymentMethods =async(state,dispatch) => {
    dispatch({
        type: "Set_FreezScreen",
        freezScreen: true,
      });
  var acceptedPayments = [...state?.storeInfo?.payments]
  if (state?.closePayments != null) {
    Object.entries(state?.closePayments).forEach(([paymentMethod, modes]) => {
    /// checking 
    let flag = false;
    let method = true;
    if (modes?.length > 0) {
      modes?.forEach((mode) => {
        if (!flag) {
          if (mode ==  "pay") {
            flag = true
          } else {
            flag = false
          }
        }
      });
    } else {
      flag = false
      method = true
    }
    /// checking flagment
    if (flag) {
      method = false
    } else {
      method = true
    }
    //// update Method
    // console.log("method", method, "=>", paymentMethod)
    if (method) {
      if (!acceptedPayments.includes(paymentMethod)) {
        acceptedPayments.push(paymentMethod);
      }
    } else {
      const filteredPaymentMethods = acceptedPayments.filter(method => method !== paymentMethod);
      acceptedPayments = [...filteredPaymentMethods]
    }
    });
  }
      dispatch({
        type: "Set_Accepted_Payments",
        acceptedPayments: acceptedPayments,
      });
  dispatch({
    type: "Set_FreezScreen",
    freezScreen: false,
  });
  
  };